export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-emerald-900 to-emerald-950 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/3294a4af19582454411e375cbd1c78be/494c4a1b567184a65b3f02374d4f7977.jpeg" 
                alt="Logo"
                className="h-12 w-auto"
              />
            </div>
            <p className="text-emerald-200 mb-4 leading-relaxed">
              Melahirkan generasi huffaz yang cemerlang dalam hafazan Al-Quran, berakhlak mulia, dan berprestasi tinggi dalam akademik.
            </p>
            <div className="flex gap-3">
              <a href="https://www.facebook.com/DarulMadadOfficial7007/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <button className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </button>
              <a href="https://www.youtube.com/@zawiyahdarulmadadsagil6299" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
              <button className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer">
                <i className="ri-telegram-fill text-xl"></i>
              </button>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Pautan Pantas</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('profil')} className="text-emerald-200 hover:text-white transition-colors cursor-pointer">Profil Madrasah</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('program')} className="text-emerald-200 hover:text-white transition-colors cursor-pointer">Program & Kurikulum</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('kemasukan')} className="text-emerald-200 hover:text-white transition-colors cursor-pointer">Kemasukan Pelajar</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('infaq')} className="text-emerald-200 hover:text-white transition-colors cursor-pointer">Infaq & Sumbangan</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('galeri')} className="text-emerald-200 hover:text-white transition-colors cursor-pointer">Galeri</button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Hubungi</h3>
            <ul className="space-y-3 text-emerald-200">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-1 flex-shrink-0"></i>
                <span>Lot 3945, Kg Sagil Parit 1, 84020 Tangkak, Johor Darul Takzim</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line flex-shrink-0"></i>
                <span>+60 6-910 2805</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-whatsapp-line flex-shrink-0"></i>
                <span>+60 19-733 4434</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line flex-shrink-0"></i>
                <span>badankebajikanzawiyahjohor@gmail.com</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Waktu Operasi</h3>
            <ul className="space-y-2 text-emerald-200">
              <li className="flex justify-between">
                <span>Isnin - Jumaat</span>
                <span className="font-semibold">8:00 - 17:00</span>
              </li>
              <li className="flex justify-between">
                <span>Sabtu</span>
                <span className="font-semibold">8:00 - 13:00</span>
              </li>
              <li className="flex justify-between">
                <span>Ahad</span>
                <span className="font-semibold">Tutup</span>
              </li>
            </ul>
            
            <div className="mt-6 p-4 bg-white/10 backdrop-blur-sm rounded-lg">
              <h4 className="font-bold mb-2">Lawati Kami</h4>
              <p className="text-sm text-emerald-200 mb-3">Hubungi kami untuk membuat temujanji lawatan</p>
              <button className="bg-yellow-500 text-emerald-900 px-4 py-2 rounded-full font-semibold hover:bg-yellow-400 transition-colors text-sm cursor-pointer whitespace-nowrap">
                Buat Temujanji
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-emerald-200 text-sm text-center md:text-left">
              &copy; 2024 Madrasah Tahfiz Al Quran Zawiyah Darul Madad. Hak Cipta Terpelihara.
            </p>
            <div className="flex items-center gap-4 text-sm">
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-emerald-200 hover:text-white transition-colors">
                Powered by Grak Xpert&nbsp;
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
